import { TabbedContentPills } from './tabbed-content-pills';
import { TabbedContentUnderline } from './tabbed-content-underline';
import { TabbedContentMobileSelect } from './tabbed-content-mobile-select';

import type { ITabs } from './types';

export const TabbedContentTabs = ({
  className = '',
  activeTab,
  setActiveTab,
  tabs,
  useUnderlineVariant = false,
}: ITabs) => {
  const Tabs = useUnderlineVariant ? TabbedContentUnderline : TabbedContentPills;

  return (
    <>
      <TabbedContentMobileSelect 
        className={className} 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        tabs={tabs} 
      />
      <Tabs className={className} activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
    </>
  );
};
